import { chain } from '@leprecoins/effector';
import { createMaster } from '@leprecoins/effector-sounds';
import { createEvent, createStore } from 'effector';
import { persist } from 'effector-storage/local';
import musicSrc from 'shared/ui/assets/sounds/music.mp3';

const setup = createEvent();

const [master, createMusic] = createMaster({ setup, autoplay: true });

const $controlledVolume = createStore(1);

export const defaultMusic = createMusic({
	src: musicSrc,
	loop: true,
	volumeScale: 0.8,
});

chain(master.$volume, $controlledVolume);

chain($controlledVolume, master.setVolume);

persist({
	store: $controlledVolume,
	key: 'leprecoins_stepball_music',
});

export const musicMaster = Object.assign(master, { setup });

export { createMusic };
